import { cva } from 'class-variance-authority';

export const buttonVariants = cva(
  'inline-flex items-center justify-center gap-2 rounded-lg text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring disabled:pointer-events-none disabled:opacity-50',
  {
    variants: {
      variant: {
        default: 'bg-accent-solid text-accent-on hover:bg-accent-solid-hover',
        secondary: 'bg-subtle text-ink hover:bg-hover',
        outline: 'border border-line-strong bg-transparent hover:bg-hover',
        ghost: 'hover:bg-hover',
        danger: 'bg-red-600 text-white hover:bg-red-700',
      },
      size: {
        sm: 'h-9 px-3',
        md: 'h-11 px-4',
        // Tablet-first staff surfaces need a 56px target (see @/lib/ui-tokens).
        lg: 'h-14 px-6 text-base',
        icon: 'h-11 w-11',
      },
    },
    defaultVariants: { variant: 'default', size: 'md' },
  },
);
